import { render } from "./LoadingComponent.vue?vue&type=template&id=d6178a30"
import script from "./LoadingComponent.vue?vue&type=script&lang=js"
export * from "./LoadingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/components/LoadingComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d6178a30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d6178a30', __exports__)) {
    api.reload('d6178a30', __exports__)
  }
  
  module.hot.accept("./LoadingComponent.vue?vue&type=template&id=d6178a30", () => {
    api.rerender('d6178a30', render)
  })

}


export default __exports__